import { render, staticRenderFns } from "./integration-list.vue?vue&type=template&id=32e8d4df&"
import script from "./integration-list.vue?vue&type=script&lang=js&"
export * from "./integration-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports